import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let WholePortionWashingPageSection: React.FC<IWorksheetComponent> = () => (
  <PageSection heading="Washing">
    <WorksheetAssociatedTestSection
      testType="Wash"
      associatedTestModel={{
        measured: true,
      }}
      name="Washing.AssociatedWashTest"
      indented={false}
    />
  </PageSection>
);

WholePortionWashingPageSection = withInjectedProps(WholePortionWashingPageSection);

export { WholePortionWashingPageSection };
export default WholePortionWashingPageSection;
